export const validatorContants = {
  REQUIRED: 'required',
  PATTERN: 'pattern',
  MIN: 'min',
  MAX: 'max',
}
